import React, { useState } from 'react';
import { get, map, fromPairs, head } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { Form } from 'modules/form';
import classnames from 'classnames';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { languagePreferences as LanguagePreferences } from 'ui/views/widgets/languagePreferences';
 *
 * // render
 * <LanguagePreferences propName='propValue'/>
 */
export const languagePreferences = ( props ) => {

    const [ langPref, setLangPref ] = useState( '' );

    const _submitUrl = get( head( get( props, 'actions', [] ) ), 'url', {} );

    return (
        <div className='ui-language-preference'>
            
            <div className='ui-language-preference__header'>

                {/* title for the modal */}
                <div className='ui-language-preference__header__title'>
                    { getLabel( props.title ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

            </div>

			<div className='ui-language-preference__body' onScroll={ props.onScroll }>

                <div className='ui-language-preference__body__subtitle'> { get( props, `data.state.${getLabel( props.subtitle )}`, '' ) } </div>

				<Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ get( props, 'values' ) } // default values
                    mode='form'
                    onSubmit={ () => {

                        if( langPref ) {
                            props.onFormSubmit( langPref, _submitUrl );

                        }
                    } }
                >
                    { ( { fields, values, /* isValid, */ errors, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-language-preference__body__form'
                            >
                                { /* fields */ }
                                { map( fields, field => {

                                    if( get( field, 'config.hide' ) ) {
                                        return null;
                                    }

                                    const fieldClassName = classnames( 'ui-language-preference__body__form__field', `ui-language-preference__body__form__${ field.name }` );
   
                                    return (
                                        <field.view
                                            className={ fieldClassName }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ null }
                                            onChange={ ( value ) => { setLangPref( value ); } }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props, `data.options.${field.options}`, [] ) }
                                            config={ field.config }
                                            mask={ field.mask }
                                            maxLength={ field.maxLength }
                                            closePopoverOnScrollTrigger={ props.closePopoverOnScrollTrigger }
                                        />
                                    );
                                } ) }

                                {/* actions */}
                                <div className='ui-language-preference__body__form__actions'>
                                    { map( props.actions, action => {
                                        const actionName = action.name;

                                        return (
                                            <Button
                                                key={ actionName }
                                                id= { actionName }
                                                type= { 'submit' !== actionName ? 'button' : 'submit' }
                                                disabled={ !langPref }
                                                outline={ 'cancel' === actionName ? true : false }
                                                size='medium'
                                                className='ui-language-preference__body__form__actions__action'
                                                { ...action }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
        </div>
    );
};

// set display name
languagePreferences.displayName = 'languagePreferences';

// set default props
languagePreferences.defaultProps = {};

// prop types
languagePreferences.propTypes = {};
